import { regionSupportedLanguages } from 'state/intl/region-supported-languages';
import { country } from 'utils/environment';

export const languageSelectorValidForRegion = (() => {
  const region = country?.toUpperCase() as keyof typeof regionSupportedLanguages | undefined;
  return !region || regionSupportedLanguages[region]?.size > 1;
})();
